import { turnSelectors, levelSelectors, hintSelectors, uiSelectors } from '~/store/selectors';
// ---- internal imports ----

import * as types from './actionTypes';
// ---- local imports ----

function _shouldHideCurrentHintOnDisplay(state, emittedAction) {
	const currentHintOnDisplay = hintSelectors.getCurrentHintOnDisplay(state);
	const currentActiveComponentName = uiSelectors.getCurrentActiveComponentName(state);

	if (currentHintOnDisplay === undefined || currentHintOnDisplay === null) {
		return false;
	}

	const { hideAfterAction, showOverComponent } = currentHintOnDisplay;

	if (hideAfterAction === undefined || hideAfterAction === null) {
		// hint without hideAfterAction handle hide itself like pop-up
		return false;
	}

	const isEmittedActionTriggerHintHide =
		_asArray(hideAfterAction).includes(emittedAction);

	const canHintShowOverCurrentComponent =
		showOverComponent === currentActiveComponentName ||
		showOverComponent === 'any';

	return isEmittedActionTriggerHintHide || !canHintShowOverCurrentComponent;
}

function isHintDisplayed(state, hintId) {
	const hintsList = hintSelectors.getHintsList(state);

	/**
	 * hint is removed from hintsList after it's displayed
	 * So, if hint still in hintsList means it's not displayed yet
	 */
	return hintsList.find((hint) => (hint.id === hintId)) === undefined;
}

function _doesPreventIfPass(state, preventIf) {
	switch (preventIf.type) {
	case 'isModalOpen':
		if (uiSelectors.isComponentVisible(state, preventIf.componentName)) {
			return true;
		}
		return false;
	case 'hintNotDisplayed':
		return !isHintDisplayed(state, preventIf.hintId);
	case 'notFirstTurnOfLevel':
		return !levelSelectors.isFirstCustomerPhaseInLevel(state);
	default:
		return false;
	}
}

function _doAnyPreventIfsPass(state, preventIfList) {
	if (preventIfList === undefined) {
		return false;
	}

	return _asArray(preventIfList)
		.some((preventIf) => _doesPreventIfPass(state, preventIf));
}

function _getNextHintToDisplay(state, emittedAction) {
	const turnNum = turnSelectors.getTurnNum(state);
	const turnPhase = turnSelectors.getTurnPhase(state);
	const hintsList = hintSelectors.getHintsList(state);
	const levelNumber = levelSelectors.getLevelNumber(state);


	const turnBaseHint =  hintsList.find((h) =>
		h.when.turnNum === turnNum
		&& h.when.phase === turnPhase
		&& _asArray(h.when.afterAction).includes(emittedAction)
		&& !_doAnyPreventIfsPass(state, h.when.preventIf));

	if (!turnBaseHint) {
		return hintsList.find((h) =>
			h.when.level === levelNumber
			&& h.when.phase === turnPhase
			&& _asArray(h.when.afterAction).includes(emittedAction)
			&& !_doAnyPreventIfsPass(state, h.when.preventIf));
	}
	else {
		return turnBaseHint;
	}
}

function _asArray(ele) {
	return Array.isArray(ele) ? [...ele] : [ele];
}

export function setHintsShown(isShown) {
	return {
		type: types.HINTS_SET_USE_HINTS,
		areHintsDisabled: !isShown
	};
}

export function reactToEmittedAction(emittedAction) {
	return async (dispatch, getState) => {
		const hintToDisplay = _getNextHintToDisplay(getState(), emittedAction);
		if (hintToDisplay !== undefined && hintToDisplay !== null) {
			dispatch({
				type: types.HINTS_SHOW_HINT,
				hintToDisplay
			});
			return;
		}

		if (_shouldHideCurrentHintOnDisplay(getState(), emittedAction)) {
			dispatch({
				type: types.HINTS_HIDE_HINT
			});
			return;
		}
	};
}

export function popUpClosed(actionAfterHint = null) {
	return async (dispatch, getState) => {
		if (actionAfterHint) {
			dispatch({type: actionAfterHint });
		}
		dispatch({ type: types.HINTS_HIDE_HINT });
	};
}

export function hideCurrent() {
	return { type: types.HINTS_HIDE_HINT };
}
